import React from 'react';
import { useCssHandles } from '../../utils/functions';
import ThirdLevel from './ThirdLevel';

const CSS_HANDLES = ['submenuItemVertical', 'collapsibleHeaderText'];

const SecondLevel = ({ name, items, blockClass }) => {
	const { handles } = useCssHandles(`vtex-mega-menu-2-x`, CSS_HANDLES, blockClass);
	const [secondLevelIsOpen, setSecondLevelIsOpen] = React.useState(false);
	const { handles: handles2 } = useCssHandles(
		`vtex-mega-menu-2-x`,
		CSS_HANDLES,
		blockClass,
		secondLevelIsOpen ? 'isOpen' : 'isClosed',
	);
	return (
		<div
			className={`${handles2.submenuItemVertical} c-on-base bb b--light-gray mv0 ph5 bt`}
			onClick={() => setSecondLevelIsOpen(!secondLevelIsOpen)}
		>
			<div class="">
				<div class="vtex-styleguide-9-x-jsFocusVisible">
					<div class="flex flex-row items-center pointer" tabindex="0" role="button" aria-expanded="false">
						<div class="flex-grow-1">
							<p className={`${handles.collapsibleHeaderText}`}>{name}</p>
						</div>
						<div class="c-muted-3 ml3  self-center">{secondLevelIsOpen ? <UpArrow /> : <DownArrow />}</div>
					</div>
					<ThirdLevel {...{ items, blockClass, secondLevelIsOpen }} />
				</div>
			</div>
		</div>
	);
};

const DownArrow = () => {
	return (
		<svg class="vtex__icon-caret-down  " width="16" height="11.428571428571429" viewBox="0 0 14 10" fill="none">
			<path
				d="M7.72356 8.48154C7.32958 8.89452 6.67042 8.89452 6.27644 8.48154L0 1.90235L1.81481 0L7 5.43529L12.1852 0L14 1.90235L7.72356 8.48154Z"
				fill="currentColor"
			></path>
		</svg>
	);
};
const UpArrow = () => {
	return (
		<svg class="vtex__icon-caret-up  " width="16" height="11.428571428571429" viewBox="0 0 14 10" fill="none">
			<path
				d="M7.72356 8.48154C7.32958 8.89452 6.67042 8.89452 6.27644 8.48154L0 1.90235L1.81481 0L7 5.43529L12.1852 0L14 1.90235L7.72356 8.48154Z"
				transform="translate(14 10) rotate(-180)"
				fill="currentColor"
			></path>
		</svg>
	);
};

export default SecondLevel;
